import './scenes/scenes-common.scss';
import { Layout } from './layout/Layout';
import { InitialRoutes } from "./common/navigation/InitalRoutes";
import React, {  } from 'react';
import { Auth0Context } from './common/Auth0/react-auth0-spa';
import { styles } from './appStyles';
import { withStyles } from '@material-ui/core';
import { StyledComponentProps, ThemeProvider } from '@material-ui/core/styles';
import { theme } from './appTheme';

interface IProps extends StyledComponentProps {
    // history: any;
}

interface IState {
    hasError: boolean,
    errorInfo: any,
}


export class App extends React.Component<IProps, IState> {

    constructor(props, context) {
        super(props, context);
        this.state = { hasError: false, errorInfo: '' };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
        this.setState(s => ({ ...s, errorInfo: errorInfo || 'empty error' }));
    }

    public render() {

        // const { loading } = useAuth0();

        // if (loading) {
        //     return <div>Loading...</div>;
        // }

        const { classes, ...otherProps } = this.props;
        return this.state.hasError ?
            `si è verificato un errore non previsto: ${JSON.stringify(this.state.errorInfo)}` :
            <Auth0Context.Consumer>{({ loading }) => loading ?
                (<div>Loading...</div>) :
                (<div className={classes.app}>
                    <InitialRoutes>
                        <ThemeProvider theme={theme}>
                            <Layout {...otherProps} />
                        </ThemeProvider>
                    </InitialRoutes>
                </div>)
            }
            </Auth0Context.Consumer>
            ;
    }
}


// export default hot(withStyles(styles)(App));
export default withStyles(styles)(App);